import { render, staticRenderFns } from "./rule-wrapper.vue?vue&type=template&id=e1d3a9a6&scoped=true"
import script from "./rule-wrapper.vue?vue&type=script&lang=ts"
export * from "./rule-wrapper.vue?vue&type=script&lang=ts"
import style0 from "./rule-wrapper.vue?vue&type=style&index=0&id=e1d3a9a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d3a9a6",
  null
  
)

export default component.exports